// extracted by mini-css-extract-plugin
export default {"note":"AppointmentSummaryNote_note__J51el","date-txt":"AppointmentSummaryNote_date-txt__FgNFW"};